let homeTopbg = '' 
let fixTopInfo = {}
const domin = window.location.hostname 
if(domin.includes('cdjm')) { // 成都军民
    homeTopbg = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/junmin/cd_top_img.png'
    fixTopInfo = {
        isPhone: false, 
        phoneNumber: [],
        isLandline: true, // 座机
        LandlineNumber: [['028','87369325']], //座机号码
        isWeixinCode: false,
        weixinCode: null,
        isQimo:true,//在线咨询
    }
} else if(domin.includes('aqjp')) {
    homeTopbg = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/anqiu/anqiu-topbg.png'

    fixTopInfo = {
        isPhone: true,
        phoneNumber: ['15853675020', '15621740229'],
        isLandline: false, // 座机
        LandlineNumber: [], //座机号码
        isWeixinCode: true,
        weixinCode: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/anqiu/fix-weixin-code.png',
        isQimo:false,//在线咨询
    }
} else if(domin.includes('tajp')) {//泰安军培
    homeTopbg = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/taian/taian-topbg.png'

    fixTopInfo = {
        isPhone: false,
        phoneNumber: [],
        isLandline: true, // 座机
        LandlineNumber: [['0538','8278181']], //座机号码
        isWeixinCode: true,
        weixinCode: null,
        weixinCodeList:[
            {
                wxCodeSrc:"https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/taian/fix_weixin_code1.png",
                txt:"退役军人事务局"
            },
            {
                wxCodeSrc:"https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/taian/fix_weixin_code2.png",
                txt:"退役军人之家"
            }
        ],
        isQimo:true,//在线咨询
    }
}else if(domin.includes('hzjp')) {//菏泽军培
    homeTopbg = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/heze/topbg.png'

    fixTopInfo = {
        isPhone: true,
        phoneNumber: ['13583031191','17806041905'],
        isLandline: false, // 座机
        LandlineNumber: [], //座机号码
        isWeixinCode: true,
        weixinCode: null,
        weixinCodeList:[
            {
                wxCodeSrc:"https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/heze/fix-weixin-code.png",
                txt:"退役军人孵化基地"
            }
        ],
        isQimo:false,//在线咨询
    }
}else {
    homeTopbg = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/heze/topbg.png'

    fixTopInfo = {
        isPhone: true,
        phoneNumber: ['13583031191','17806041905'],
        isLandline: false, // 座机
        LandlineNumber: [], //座机号码
        isWeixinCode: true,
        weixinCode: null,
        weixinCodeList:[
            {
                wxCodeSrc:"https://wd-appdownload.oss-cn-beijing.aliyuncs.com/junmin/heze/fix-weixin-code.png",
                txt:"退役军人孵化基地"
            }
        ],
        isQimo:false,//在线咨询
    }
}

export default {
    homeTopbg, 
    fixTopInfo

}